import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface AudienceCard {
  id: string;
  icon: string;
  title: string;
  description: string;
  color: string;
  displayOrder: number;
  isActive: boolean;
}

export const useAudienceCards = () => {
  const [cards, setCards] = useState<AudienceCard[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCards = async () => {
    try {
      setIsLoading(true);
      const { data, error: fetchError } = await supabase
        .from('audience_cards')
        .select('*')
        .eq('is_active', true)
        .order('display_order');

      if (fetchError) throw fetchError;

      const transformedCards = (data || []).map(card => ({
        id: card.id,
        icon: card.icon,
        title: card.title,
        description: card.description,
        color: card.color,
        displayOrder: card.display_order,
        isActive: card.is_active,
      }));

      setCards(transformedCards);
      setError(null);
    } catch (err) {
      console.error('Error fetching audience cards:', err);
      setError('Failed to load audience cards');
      setCards([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);

  return { cards, isLoading, error, refetch: fetchCards };
};
